import { componentSizes } from '@/theme/componentSizes';
import { r, s } from '@/theme/tokens';
import { Box, Skeleton } from '@/ui/primitives';
import { MetricTrendCardFrame } from './MetricTrendCardFrame';
import { metricTrendCardCompactLayout } from './MetricTrendCardFrame.layout';
import type { SxProps, Theme } from '@/ui/primitives';
import type { ReactElement } from 'react';

const cardSkeletonBarHeight = componentSizes.dataGrid.skeletonHeight;

type MetricTrendCardSkeletonProps = {
  sx?: Exclude<Extract<SxProps<Theme>, readonly unknown[]>[number], boolean>;
};

export const MetricTrendCardSkeleton = ({ sx }: MetricTrendCardSkeletonProps): ReactElement => {
  const titleNode = (
    <Skeleton
      variant="rounded"
      width={92}
      height={cardSkeletonBarHeight}
      sx={{ borderRadius: r('pill') }}
    />
  );
  const middleNode = (
    <Skeleton
      variant="rounded"
      width="min(100%, 132px)"
      height={cardSkeletonBarHeight}
      sx={{ borderRadius: r('pill') }}
    />
  );
  const footerNode = (
    <Skeleton
      variant="rounded"
      width="min(100%, 84px)"
      height={cardSkeletonBarHeight}
      sx={{ borderRadius: r('pill') }}
    />
  );

  return (
    <MetricTrendCardFrame
      title={titleNode}
      titleFontSize={undefined}
      sx={sx}
      minHeight={metricTrendCardCompactLayout.minHeight}
      chartHeight={metricTrendCardCompactLayout.chartHeight}
      fixedHeight
      headerPaddingX={metricTrendCardCompactLayout.headerPaddingX}
      headerPaddingTop={s('lg')}
      headerPaddingBottom={s('none')}
      middleGridTemplateColumns="minmax(0, 1fr) 0"
      middleColumnGap={s('none')}
      middlePaddingY={metricTrendCardCompactLayout.middlePaddingY}
      value={
        <Box sx={{ width: '100%', minWidth: 0, pr: s('4xl'), boxSizing: 'border-box' }}>
          {middleNode}
        </Box>
      }
      valuePaddingX={metricTrendCardCompactLayout.valuePaddingX}
      valuePaddingRight={metricTrendCardCompactLayout.valuePaddingX}
      valuePaddingY={metricTrendCardCompactLayout.valuePaddingY}
      chart={null}
      chartPaddingX={s('none')}
      footer={footerNode}
      footerPaddingX={metricTrendCardCompactLayout.footerPaddingX}
      footerPaddingTop={s('none')}
      footerPaddingBottom={s('xl')}
      footerSx={{ gap: s('xs') }}
    />
  );
};
